<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      pointer-events="none"
      d="M12.0001 13.4143L16.9394 18.3536C17.1347 18.5489 17.4513 18.5489 17.6465 18.3536L18.3536 17.6465C18.5489 17.4513 18.5489 17.1347 18.3536 16.9394L13.4143 12.0001L18.3536 7.06074C18.5489 6.86547 18.5489 6.54889 18.3536 6.35363L17.6465 5.64652C17.4513 5.45126 17.1347 5.45126 16.9394 5.64652L12.0001 10.5859L7.06074 5.64652C6.86547 5.45126 6.54889 5.45126 6.35363 5.64652L5.64652 6.35363C5.45126 6.54889 5.45126 6.86547 5.64652 7.06074L10.5859 12.0001L5.64652 16.9394C5.45126 17.1347 5.45126 17.4513 5.64652 17.6465L6.35363 18.3536C6.54889 18.5489 6.86547 18.5489 7.06074 18.3536L12.0001 13.4143Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      default: '#152E39',
      type: String,
    },
  },
}
</script>
